import ApiClient from './ApiClient';

class CrmStagesAPI extends ApiClient {
  constructor() {
    super('crm_stages', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }

  show(id) {
    return axios.get(`${this.url}/${id}`);
  }

  create(data) {
    return axios.post(this.url, { crm_stage: data });
  }

  update(id, data) {
    return axios.patch(`${this.url}/${id}`, { crm_stage: data });
  }

  delete(id, params = {}) {
    return axios.delete(`${this.url}/${id}`, { params });
  }

  reorder(stages) {
    return axios.post(`${this.url}/reorder`, { stages });
  }
}

export default new CrmStagesAPI();
